<template>
  <v-card class="pa-3">
    <v-dialog v-model="dialog_bloqueo" persistent width="500">
      <v-card class="elevation-0">
        <v-toolbar class="mb-0" dark color="success">
          <v-toolbar-title>
            {{ $t('aviso') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <h2>{{ $t('msg_documentation_completed') }}</h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card-title>Archivos requeridos para la invitacion</v-card-title>
    <v-card-text>
      <v-divider class="my-3"></v-divider>

      <v-container grid-list-lg fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 v-for="(archivo, index) in archivos" :key="index">

            <!-- Hidden File Input -->
            <input type="file" :ref="'fileInput' + index" style="display: none" :accept="acceptedFileTypes"
              @change="onFileChange($event, index)" />

            <!-- DOCUMENT CARD -->
            <v-card height="100%" class="d-flex flex-column" :class="{
              'dashed-border': !archivo,
              'elevation-2': archivo,
              'elevation-0': !archivo,
              'grey lighten-4': !archivo
            }" style="cursor: pointer; position: relative; min-height: 200px;"
              @click="!archivo || archivo.error ? triggerFileInput(index) : null">

              <!-- STATE: EMPTY / INITIAL -->
              <div v-if="!archivo" class="fill-height layout column align-center justify-center pa-4 text-xs-center">
                <v-icon large color="grey darken-1" class="mb-3">cloud_upload</v-icon>
                <div class="subheading grey--text text--darken-2 font-weight-bold mb-1">{{
                  documentationOptions[index].name }}</div>
                <div class="caption grey--text">Click para subir archivo</div>
              </div>

              <!-- STATE: LOADING (Analyizing) -->
              <div v-else-if="archivo.loading"
                class="fill-height layout column align-center justify-center pa-4 text-xs-center">
                <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
                <div class="body-1 blue--text text--darken-2 font-weight-bold">{{ documentationOptions[index].name }}
                </div>
                <div class="caption grey--text mt-1">Analizando documento...</div>
              </div>

              <!-- STATE: SUCCESS or ERROR -->
              <div v-else class="fill-height layout column align-center justify-center pa-3 text-xs-center"
                style="width: 100%">

                <!-- ERROR Display -->
                <div v-if="archivo.error || (archivo.validations && archivo.validations.is_current === false)"
                  style="width: 100%">
                  <v-icon large color="error" class="mb-2">error_outline</v-icon>
                  <div class="subheading font-weight-bold mb-1 ml-1 mr-1 text-truncate">{{
                    documentationOptions[index].name }}</div>

                  <v-alert :value="true" type="error" outline class="caption pa-1 mb-2">
                    <div v-if="archivo.error">{{ archivo.error }}</div>
                    <div v-if="archivo.validations && archivo.validations.is_current === false">Documento vencido</div>
                  </v-alert>

                  <v-btn small outline color="error" @click.stop="triggerFileInput(index)">
                    <v-icon left small>refresh</v-icon> Reintentar
                  </v-btn>
                  <v-btn v-if="archivo.ocrData" small flat color="error" @click.stop="openOcrDetails(archivo)">
                    <v-icon left small>visibility</v-icon> Ver Datos
                  </v-btn>
                </div>

                <!-- SUCCESS Display -->
                <div v-else style="width: 100%">
                  <v-icon large color="success" class="mb-2">check_circle</v-icon>
                  <div class="subheading font-weight-bold mb-1 text-truncate">{{ documentationOptions[index].name }}
                  </div>
                  <div class="green--text font-weight-bold caption mb-2">Validado correctamente</div>
                  <div class="grey--text caption mb-3">{{ humanFileSize(archivo.file.size) }}</div>

                  <v-layout row justify-center>
                    <v-btn v-if="!archivo.ocrSkipped" small flat color="primary" @click.stop="openOcrDetails(archivo)">
                      <v-icon left small>visibility</v-icon> Ver Datos
                    </v-btn>
                    <v-btn small icon flat color="grey" @click.stop="triggerFileInput(index)">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
              </div>

            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- OCR Details Dialog -->
      <v-dialog v-model="detailsDialog" width="400">
        <v-card v-if="selectedOcrFile">
          <v-card-title class="headline grey lighten-2 pa-3">
            Datos Extraídos
          </v-card-title>
          <v-card-text class="pa-3">
            <v-alert :value="true" type="info" outline class="caption mb-3 pa-2">
              Estos datos son extraídos automáticamente. Por favor verifique que sean correctos.
            </v-alert>

            <!-- Información de Validación -->
            <div v-if="selectedOcrFile.validations" class="mb-3">
              <v-divider class="mb-2"></v-divider>
              <div class="caption grey--text text--darken-1 mb-2"><strong>Información de Validación</strong></div>

              <div v-if="selectedOcrFile.validations.is_current !== undefined" class="mb-2">
                <strong class="caption grey--text text--darken-1">Vigencia</strong>
                <div class="body-1">
                  <v-chip small :color="selectedOcrFile.validations.is_current ? 'success' : 'error'"
                    text-color="white">
                    {{ selectedOcrFile.validations.is_current ? 'Vigente' : 'Vencido' }}
                  </v-chip>
                </div>
              </div>

              <div v-if="selectedOcrFile.validations.valid_until" class="mb-2">
                <strong class="caption grey--text text--darken-1">Válido hasta</strong>
                <div class="body-1">{{ selectedOcrFile.validations.valid_until }}</div>
              </div>

              <v-divider class="mt-2 mb-2"></v-divider>
            </div>

            <div v-if="selectedOcrFile.ocrData">
              <div v-for="(value, key) in selectedOcrFile.ocrData" :key="key" class="mb-2">
                <strong class="caption grey--text text--darken-1">{{ formatFieldName(key) }}</strong>
                <div class="body-1">{{ formatFieldValue(value) }}</div>
              </div>
            </div>
            <div v-else class="text-xs-center grey--text">
              No hay datos extraídos disponibles.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="detailsDialog = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card-text>

    <v-card-actions>
      <v-btn :loading="loading" color="primary" :disabled="!puedeSubir" @click="subirArchivos">
        Subir archivos
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

const FALLBACK_OCR_TYPES = [
  {
    "type_id": "curp",
    "name": "CURP",
    "description": "Constancia de la Clave Única de Registro de Población",
    "fields": ["curp", "nombre", "fecha_inscripcion", "folio", "entidad"]
  },
  {
    "type_id": "rfc",
    "name": "RFC / Constancia de Situación Fiscal",
    "description": "Constancia de Situación Fiscal emitida por el SAT",
    "fields": ["RFC", "razon_social", "nombre_comercial", "regimen_capital", "fecha_inicio", "estatus", "regimen_fiscal", "codigo_postal"]
  },
  {
    "type_id": "dc3",
    "name": "DC-3",
    "description": "Constancia de Competencias o Habilidades Laborales",
    "fields": ["nombre_trabajador", "curp_trabajador", "ocupacion", "puesto", "nombre_empresa", "rfc_empresa", "nombre_curso", "duracion_horas", "fecha_inicio", "fecha_fin", "area_tematica", "agente_capacitador"]
  },
  {
    "type_id": "opinion_cumplimiento",
    "name": "Opinión de Cumplimiento",
    "description": "Opinión del cumplimiento de obligaciones fiscales (32-D)",
    "fields": ["RFC", "razon_social", "sentido", "folio", "fecha_emision", "vigente"]
  },
  {
    "type_id": "cedula_sua",
    "name": "Cédula SUA",
    "description": "Cédula de Determinación de Cuotas del Sistema Único de Autodeterminación",
    "fields": ["registro_patronal", "RFC", "razon_social", "actividad", "bimestre", "fecha_proceso", "delegacion_imss", "subdelegacion_imss", "total_cotizantes", "total_rcv", "total_infonavit"]
  },
  {
    "type_id": "linea_captura_imss",
    "name": "Línea de Captura IMSS",
    "description": "Formato para pago de cuotas obrero patronales del IMSS",
    "fields": ["registro_patronal", "RFC", "razon_social", "delegacion", "subdelegacion", "periodo_imss", "bimestre_rcv", "fecha_limite", "total_pagar", "linea_captura", "folio_sua", "num_cotizantes"]
  }
];

export default {
  data() {
    return {
      loading: false,
      dialog_bloqueo: false,
      detailsDialog: false,
      selectedOcrFile: null,
      numArchivos: 0, // cantidad inicial
      archivos: [],   // arreglo con objetos { file, error }
      maxFileSize: 2 * 1024 * 1024, // 2MB
      acceptedFileTypes: '.pdf,image/*', // Tipos de archivo permitidos
      documentationOptions: [], // Tipos de documentación desde la API
      ocrSupportedTypes: [],
    };
  },
  mounted() {
    this.fetchDocumentationTypes()
    this.fetchOcrTypes()
    this.userId = this.$route.params['idUser']
  },
  computed: {
    puedeSubir() {
      // Permitir subir solo si todos los archivos están cargados, validados y vigentes.
      return this.archivos.length > 0 &&
        this.archivos.every(a =>
          a &&
          a.file &&
          !a.loading &&
          !a.error &&
          (!a.validations || a.validations.is_current !== false)
        );
    }
  },
  methods: {
    formatFieldName(key) {
      if (!key) return '';
      if (this.$te(key)) return this.$t(key);
      // Reemplazar guiones bajos por espacios y capitalizar
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    formatFieldValue(value) {
      if (typeof value === 'boolean') {
        return value ? this.$t('Si') : 'No';
      }
      return value;
    },
    async fetchOcrTypes() {
      try {
        const response = await axios.get('https://microservices.intrare.app/ocr/document/types/');
        if (response.data && Array.isArray(response.data)) {
          this.ocrSupportedTypes = response.data;
        } else if (response.data && Array.isArray(response.data.types)) {
          this.ocrSupportedTypes = response.data.types;
        } else {
          console.warn('Unexpected OCR types format, using fallback.', response.data);
          this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
        }
      } catch (e) {
        console.error("Error fetching OCR types, using fallback.", e);
        this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
      }
    },
    async fetchDocumentationTypes() {
      console.log("Fetching documentation types...")
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/get_documentation_byuser_byinvitation/' + this.$route.params['idInvitation'] + '/' + this.$route.params['idUser'],
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
        },
      };
      axios(config)
        .then(result => {
          this.documentationOptions = result.data
          this.numArchivos = result.data.length
          const nuevoArr = []
          for (let i = 0; i < this.documentationOptions.length; i++) {
            nuevoArr.push(null)
          }
          this.archivos = nuevoArr
          if (result.data.length === 0) {
            this.dialog_bloqueo = true
            console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
          }
          console.log(this.documentationOptions)
          console.log('Valor de archivos = ', this.archivos)
        })
        .catch(error => {
          console.log(error)
        })
    },
    async onFileChange(e, index) {
      const file = e.target.files[0];
      const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'].includes(file.type)

      if (!file) {
        this.$set(this.archivos, index, null);
        return;
      }

      let error = null;
      if (file.size > this.maxFileSize) {
        error = `El archivo supera los ${this.humanFileSize(this.maxFileSize)}`;
      } else if (!isValidType) {
        error = "El archivo debe ser PDF o imagen (JPEG/PNG).";
      }

      if (error) {
        this.$set(this.archivos, index, { file, error, loading: false });
        return;
      }

      // Iniciar carga local
      this.$set(this.archivos, index, { file, error: null, loading: true });

      // Inicia validación OCR
      try {
        const docName = this.documentationOptions[index].name.toLowerCase();
        let docType = null;

        console.log('Validando documento:', docName);
        console.log('Tipos soportados cargados:', this.ocrSupportedTypes ? this.ocrSupportedTypes.length : 0);

        if (this.ocrSupportedTypes && this.ocrSupportedTypes.length > 0) {
          const match = this.ocrSupportedTypes.find(type => {

            const typeValue = typeof type === 'string' ? type : (type.type_id || type.type || '');
            const val = typeValue.toLowerCase();

            if (docName.includes(val)) {
              console.log('Match exacto:', val);
              return true;
            }

            if (docName.includes(val.replace(/_/g, ' '))) {
              console.log('Match con espacios:', val);
              return true;
            }

            if (val === 'cedula_sua' && docName.includes('sua') && !docName.includes('comprobante')) {
              console.log('Match alias SUA:', val);
              return true;
            }
            if (val === 'linea_captura_imss' && (docName.includes('linea') || docName.includes('captura'))) {
              console.log('Match alias Linea Captura:', val);
              return true;
            }
            if (val === 'opinion_cumplimiento' && docName.includes('opinion')) {
              console.log('Match alias Opinion:', val);
              return true;
            }

            return false;
          });

          if (match) {
            docType = typeof match === 'string' ? match : (match.type_id || match.type);
          }
        } else {
          console.warn('Alerta: No hay tipos de OCR cargados. Usando validación local.');
        }

        if (!docType) {
          console.log(`Documento '${docName}' no soportado por OCR o no match. Saltando validación.`);
          this.$set(this.archivos, index, {
            file,
            error: null,
            loading: false,
            ocrSkipped: true // Indica que no se realizó validación OCR
          });
          return;
        }

        const formData = new FormData();
        formData.append('document', file);
        formData.append('document_type', docType);

        const response = await axios.post('https://microservices.intrare.app/ocr/document/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-api-key': '63f6f7729962518de2073625d1e61be17d5f99b5',
          }
        });

        // Siempre guardamos la respuesta completa para mostrarla
        const ocrResult = response.data;

        let fileError = null;
        if (!ocrResult.success) {
          fileError = ocrResult.errors ? ocrResult.errors.join(', ') : 'No se pudo validar el documento.';
        }

        // Almacenar todos los campos nuevos del OCR
        this.$set(this.archivos, index, {
          file,
          error: fileError,
          loading: false,
          ocrData: ocrResult.extracted_data,
          validations: {
            ...ocrResult.validations,
            is_valid: ocrResult.success,
            is_current: ocrResult.validations && ocrResult.validations.is_current,
            valid_until: ocrResult.valid_until,
            ocr_confidence: ocrResult.ocr_confidence
          }
        });


      } catch (err) {
        console.error('OCR Error', err);
        this.$set(this.archivos, index, { file, error: "No se pudieron extraer datos del documento.", loading: false });
      }
    },
    humanFileSize(size) {
      if (size === 0) return "0 B";
      const i = Math.floor(Math.log(size) / Math.log(1024));
      const sizes = ["B", "KB", "MB", "GB"];
      return (size / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    },
    async subirArchivos() {
      this.loading = true
      const formData = new FormData();
      formData.append('user_id', this.userId);

      // Preparar validation_results para cada archivo
      const validationResults = [];

      this.archivos.forEach((archivo, index) => {
        if (archivo && archivo.file) {
          formData.append('files', archivo.file);
          formData.append('documentation_ids', this.documentationOptions[index].id);

          const validationResult = {
            success: !archivo.error && !archivo.ocrSkipped,
            validations: archivo.validations || {},
            valid_until: (archivo.validations && archivo.validations.valid_until) || null,
            ocr_confidence: (archivo.validations && archivo.validations.ocr_confidence) || null,
            errors: archivo.error ? [archivo.error] : [],
            extracted_data: archivo.ocrData || {}
          };


          validationResults.push(JSON.stringify(validationResult));
        }
      });

      validationResults.forEach(result => {
        formData.append('validation_results', result);
      });

      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/upload-documents-by-user/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
        },
        data: formData
      };

      axios(config)
        .then(ok => {
          this.loading = false
          this.fetchDocumentationTypes()
          alert("Archivos subidos correctamente.")
        })
        .catch(error => {
          this.loading = false
          alert("Error de red o del servidor.")
          console.error(error)
        })
        .finally(() => (this.loading = false))
    },
    triggerFileInput(index) {
      const refName = 'fileInput' + index;
      const elem = this.$refs[refName];
      if (elem && elem[0]) {
        elem[0].value = '';
        elem[0].click();
      } else if (elem) {
        elem.value = '';
        elem.click();
      }
    },
    openOcrDetails(archivo) {
      this.selectedOcrFile = archivo;
      this.detailsDialog = true;
    }
  }
};
</script>

<style scoped>
.dashed-border {
  border: 2px dashed #e0e0e0 !important;
}
</style>
